import useSound from "use-sound";

export function useClickSound() {
    return useSound("/audio/154953__keykrusher__microwave-beep.wav");
}